// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  --background: transparent;
  position: absolute;
}

.mybutton {
  --background: var(--ion-color-primary);
  --border-radius: 30px;
  width: calc(328 * var(--width-ratio));
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modal/use-coin-modal/use-coin-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,sCAAA;EACA,qBAAA;EACA,qCAAA;AACF","sourcesContent":["ion-toolbar {\n  --background: transparent;\n  position: absolute;\n}\n\n.mybutton {\n  --background: var(--ion-color-primary);\n  --border-radius: 30px;\n  width: calc(328 * var(--width-ratio));\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
